import { render, staticRenderFns } from "./BHero.vue?vue&type=template&id=c8d4f5c2&scoped=true&"
import script from "./BHero.vue?vue&type=script&lang=js&"
export * from "./BHero.vue?vue&type=script&lang=js&"
import style0 from "./BHero.vue?vue&type=style&index=0&id=c8d4f5c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d4f5c2",
  null
  
)

export default component.exports